import configHelper from '@/config/ConfigHelper'

function GenerateConfig () {
  return [
    {
      id: 1,
      esquema: 'NO_VALID',
      types: ['issued', 'received', 'verifactu'],
      multiple: false
    },
    {
      id: 1,
      esquema: 'FACTURAE',
      types: ['issued', 'received'],
      multiple: false
    },
    {
      id: 2,
      esquema: 'ZCPGE',
      types: ['issued'],
      multiple: true
    },
    {
      id: 3,
      esquema: 'ESQZCPGE',
      types: ['issued'],
      multiple: true
    },
    {
      id: 4,
      esquema: 'TXT',
      types: ['issued'],
      multiple: false
    },
    {
      id: 5,
      esquema: 'ROCHLING',
      types: ['issued'],
      multiple: false
    },
    {
      id: 6,
      esquema: 'EFR',
      types: ['received'],
      multiple: false
    },
    {
      id: 7,
      esquema: 'VERIFACTU',
      types: ['verifactu'],
      multiple: false
    },
    {
      id: 8,
      esquema: 'EXCEL',
      types: ['issued'],
      multiple: true
    }
  ]
}

export function TIPOS_ESQUEMA (state) {
  return configHelper.getConfig(state, 'TIPOS_ESQUEMA', GenerateConfig, false)
}
